import emailjs from '@emailjs/browser';
import React, { useRef } from "react";
import { FaPhoneAlt } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import Button from "../../components/Button";

import SocialLinks from "../../components/SocialLinks";

const Contact = () => {

  const form = useRef()

// email send functions

const sendMail = (e)=>{
  e.preventDefault();

  emailjs.sendForm('service_vo6025o', 'template_v92kfp5', form.current, 'RcoJZZ4JLEPWpl-o_')
  .then((result) => {
      alert(result.text);
  }, (error) => {
     alert(error.text);
  });

}




  return (
    <div className="min-h-screen w-full ">
      <div className="contactBody px-10 py-20">
        <div className="introbody">
          <h1 className="text-5xl   text-white font-extrabold uppercase mb-20">
            Contact
            <span className="text-primary"> ME</span>
          </h1>

          {/* main Contact section */}

          <div className="grid grid-cols-12 gap-5">
            <div className="col-span-12 lg:col-span-5">
              <h2 className="text-2xl  border-b-4 pr-4 border-primary inline-block  pb-3 font-bold uppercase tracking-wide mb-8">
                Address
              </h2>
              <div className="adress">
                <p className="font-medium ">
                  Netrakona, Mymensingh, Bangladesh
                </p>
                <div className="phone flex items-center mt-2">
                  <FaPhoneAlt />
                  <span className="ml-3 ">+8801771517322</span>
                </div>

                <div className="email flex items-center mt-2">
                  <HiOutlineMail />
                  <span className="ml-3 ">coddermoon@gmail.com</span>
                </div>

                {/* socialLinks */}
                <SocialLinks />
              </div>
            </div>
            {/* form */}
            <div className="col-span-12 lg:col-span-7">
              <h2 className="text-2xl  border-b-4 border-primary inline-block  pb-3 font-extrabold uppercase tracking-wide mb-8">
                SEND ME A NOTE
              </h2>

              <form 
              ref={form}
              onSubmit={sendMail}>
                <input
                  className="w-full bg-bgSecondary my-3 border border-primary rounded py-2 px-4 text-xl"
                  type="text"
                  name="subject"
                  placeholder="subject"
                />
                {/* name and subject  */}
                <div className="grid lg:grid-cols-2 md:grid-cols-2 my-3 gap-5">
                  <input
                    className="w-full bg-bgSecondary border border-primary rounded py-2 px-4 text-xl"
                    type="text"
                    name="name"
                    placeholder="name"
                  />

                  <input
                    className="w-full bg-bgSecondary border border-primary rounded py-2 px-4 text-xl"
                    type="text"
                    name="email"
                    placeholder="email adress"
                  />
                </div>

                <textarea
                  className="w-full my-3 bg-bgSecondary border border-primary rounded py-2 px-4 text-xl h-80"
                  name="message" placeholder="Type message"
                ></textarea>


<Button className="bg-bgSecondary uppercase">SEND</Button>

               
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
